import { memo, useCallback, useState } from 'react';
import { logError } from '@betty/toolkit/logging';
import { Box, Button, Checkbox, Text } from '@betty/moonlight';
import { WithdrawConfirmationProps } from './WithdrawConfirmation.types';
import WithdrawService from '../../services/WithdrawService/WithdrawService';

function WithdrawConfirmation({
  transactionId,
  close,
}: WithdrawConfirmationProps) {
  const [loading, setLoading] = useState(false);
  const [confirmed, setConfirmed] = useState(false);

  const onConfirm = useCallback(async () => {
    if (!confirmed) {
      return;
    }

    try {
      setLoading(true);

      await WithdrawService.confirm({ pathParams: { transactionId } });

      close();
    } catch (error) {
      logError('Withdraw confirmation request failure.', error);
    } finally {
      setLoading(false);
    }
  }, [confirmed, transactionId, close]);

  return (
    <Box paddingTop="space-400" gap="space-400">
      <Text
        variant="h5"
        locNS="wallet"
        locKey="withdrawConfirmationTitle"
        color="darkSurfacePrimary"
      />
      <Text
        variant="body-m"
        locNS="wallet"
        locKey="withdrawConfirmationDescription"
        color="darkSurfacePrimary"
      />
      <Checkbox
        variant="default"
        labelNS="wallet"
        labelKey="withdrawConfirmationAgreement"
        alignItems="flex-start"
        gap="space-200"
        checked={confirmed}
        onChange={setConfirmed}
      />
      <Box flexDirection="row" marginTop="space-600" gap="space-200">
        <Button
          flex={1}
          variant="secondary"
          locNS="common"
          locKey="close"
          onPress={close}
        />
        <Button
          flex={1}
          locNS="common"
          locKey="confirm"
          loading={loading}
          disabled={!confirmed}
          onPress={onConfirm}
        />
      </Box>
    </Box>
  );
}

export default memo(WithdrawConfirmation);
